module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyBAMAAABYG2ONAAAAD1BMVEXZABKQEUIAM6CigjXyqABwofRbAAAAJklEQVR4AWNhIBmMXC2jWka1CJKnZTSQR7WMahnNYgOvZVTLqBYAVK0BDTB0dX0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/am.png
// module id = ZUNP
// module chunks = 0